import { tw, variants } from 'classname-variants';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import { createElement } from 'react';

const typeVariants = variants({
  variants: {
    typography: {
      subheading: tw`text-h5 mb-4 uppercase`,
      undefined: '',
    },
  },
});

export type TypeProps = React.HTMLAttributes<HTMLDivElement> & {
  as: // All valid HTML text elements
  | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'p'
    | 'dt'
    | 'dd'
    | 'span'
    | 'small'
    | 'div'
    | 'figcaption'
    | 'strong'
    | 'code'
    | 'em'
    | 's'
    | 'u'
    | 'blockquote'
    | 'q'
    | 'li';
  typography?: 'subheading' | 'undefined';
  className?: string;
  children: ReactNode;
};

export const Type = ({
  as = 'p',
  typography = 'undefined',
  className,
  children,
  ...rest
}: TypeProps) => {
  if (!children) {
    return null;
  }

  return createElement(
    as,
    {
      className: classNames(
        typeVariants({ typography }),
        'break-words',
        'ff-type',
        'overlayOverBkg',
        className
      ),
      ...rest,
    },
    children
  );
};
